// 站内信-主页
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="列表" name="second">

        <div style=" height: calc(100vh - -40px);">
          <vxe-grid show-overflow :stripe="true" border="default" :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption" height="100%"
            @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
            :checkbox-config="{ labelField: '', highlight: true, reserve: true, range: true }">

            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl">
                </div>
                <div class="fr" style="display: flex;">
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;" class="button-sty"
                    @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>

                <vxe-form ref="form" class="screen-box" title-width="5vw" title-align="right" :data="formData"
                @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                  <vxe-form-item title="工单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.orderNo" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="回复状态:" field="relpyStatus" >
                    <template v-slot>
                    <el-select v-model="formData.relpyStatus" style="width: 8vw;" clearable >
                      <el-option :value="Number(0)" label="无须回复"></el-option>
                      <el-option :value="Number(1)" label="待回复"></el-option>
                      <el-option :value="Number(2)" label="已回复"></el-option>
                    </el-select>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="标题:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.title" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>


                  <vxe-form-item title="创建时间:" field="name" style="width:25%!important;">
                    <template v-slot style=" display: inline-block;width:25%!important;">
                      <el-date-picker style="width: 18vw;" v-model="formData.createDate" type="daterange" align="right"
                        unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                        :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="回复时间:" field="replyTime" style="width:25%!important;">
                    <template v-slot style=" display: inline-block;width:25%!important;">
                      <el-date-picker style="width: 18vw;" v-model="formData.replyTime" type="daterange" align="right"
                                      unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>
                </vxe-form>


            </template>
            <template #option="{row}">
              <div >
                <a href="javascript:void(0);"  class="a-link" @click="openEditDialog(row)">
                  <el-tooltip :enterable=false effect="dark" content="回复" placement="top"
                              popper-class="tooltip-skin">
                    <i class="el-icon-edit"/>
                  </el-tooltip>
                </a>

              </div>
            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>


          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
    <replyDialog v-if="showReplyDialog" @commitReply="commitReply" :visiable.sync="showReplyDialog"
                 :param="this.replyParams"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import api from "@/api/projectApi";
import request from "@/router/axios";
import pager from '@/components/pager/index.vue'
import { initVxeTable } from '@/const/crud/admin/table';
import replyDialog from './replyDialog.vue'

export default {
  name: 'messageBotify',

  inject: ['reload'],
  props: {
    workTypeName: String
  },
  components: {  pager,replyDialog

  },
  data() {
    return {
      replyParams:{},
      showReplyDialog:false,
      total: 0,
      editViewType: null,
      requestParam: {
        // workType:1,
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量

        relpyStatus: null,
        orderNo: null,
        createDate: null,
        createTimeBegin: null,
        createTimeEnd: null,
        replyTimeBegin:null,
        replyTimeEnd:null,
        title:null,
      },

      formData: {

        relpyStatus: null,
        orderNo: null,
        createDate: null,
        createTimeBegin: null,
        createTimeEnd: null,
        replyTimeBegin:null,
        replyTimeEnd:null,
        title:null,


      },

      sitePromptList: [],


      input: '',


      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      activeName: 'second',
      dataId: 0,

      vxeOption: {},
      pageSizes: [10, 20, 100],
      showEdit: false,
      columns: [
        { width: 100, field: 'status', fixed: 'right', title: '操作', showOverflow: true, slots: { default: 'option' } },
        {
          title: '工单号', field: 'orderNo', width: 200, slots: {
            filter: 'age_filter',
            default: ({row}) => {
              return [
                <span style="color: blue"
                      onClick={($event) => this.addressClickEvent(row)}>{row.orderNo}</span>
              ]
            }
          }
        },
        {
          title: '工程师', field: 'engineerName', width: 180
        },
        {
          title: '标题', field: 'title', width: 180
        },
        {
          title: '内容', field: 'content', width: 180
        },
        {
          title: '创建时间', field: 'createTime', width: 180
        },
        { title: '回复状态', field: 'relpyStatus', width: 125, slots: {
            default: ({ row }) => {
              if (row.relpyStatus == 0) {
                return [
                  <div class="txt-status ">
                    <span>无须回复</span>
                  </div>
                ];
              } else if (row.relpyStatus == 1) {
                return [
                  <div class="txt-status neutral">
                    <span>待回复</span>
                  </div>
                ];
              }else if (row.relpyStatus == 2) {
                return [
                  <div class="txt-status ">
                    <span>已回复</span>
                  </div>
                ];
              }
            }
          } },

        { title: '回复人', field: 'replyMan', width: 100, },

        { title: '回复内容', field: 'replyContent', width: 100, },
        { title: '回复时间', field: 'replyTime', width: 150, },


      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    'formData.createDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.createTimeBegin = newVal[0]
          this.formData.createTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.createTimeBegin = null
          this.formData.createTimeEnd = null
        }
      },
      deep: true,
    },
    'formData.replyTime': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.replyTimeBegin = newVal[0]
          this.formData.replyTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.replyTimeBegin = null
          this.formData.replyTimeEnd = null
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.$route.query.orderNo && this.$route.query.orderNo!=='0'){
      console.log("this.$route.query.orderNo------",this.$route.query.orderNo)
      this.formData.orderNo = this.$route.query.orderNo
      this.requestParam.orderNo = this.$route.query.orderNo
    }else if (this.$route.query.orderNo && this.$route.query.orderNo==='0'){
      this.formData.relpyStatus = 1
      this.requestParam.relpyStatus = 1
    }
  },

  mounted() {

    this.initSearchDate()
    this.getTableData()


  },

  methods: {
    addressClickEvent(row){
      this.$router.push({ path: '/workorder/business/center/index', query: { replyOrderNo: row.orderNo } })  // 根据路由路径 + query 的方式跳转传参
    },
    toFilterData() {
            this.searchEvent();
     },


    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },
    openEditDialog(row){
      this.replyParams = {id:row.id,orderNo:row.orderNo}
      this.showReplyDialog = true
    },
    commitReply(type){
      this.showReplyDialog = false
      if (type == 1){
        this.flushed()
      }
    },

    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.createDate = [start, end]
      this.requestParam.createTimeBegin = start
      this.requestParam.createTimeEnd = end
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },





    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },
    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: '/basic/soOrderOperationReply/getListPage',
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },

    // 搜索
    searchEvent() {
      console.log(this.formData,"搜索");
      // this.requestParam.fuzzySearchIsEnable = !this.showMoreOptions
      this.$objCopy(this.formData, this.requestParam)

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

















  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏
.screen-box {
  display: flex;


}

::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}

// ::v-deep .vxe-grid .vxe-form .vxe-form--item.is--active:not(.is--hidden) {
//   display: inline-block;
//   width: 20%;
// }

::v-deep .vxe-grid .el-input .el-input__inner {
  height: 28px !important;
}
</style>
